import PropTypes from 'prop-types';
import React from 'react';

const propTypes = {
    color: PropTypes.string,
    className: PropTypes.string,
};

const ArrowIcon = ({ color = 'currentColor', className = null }) => (
    <svg
        width="18"
        height="12"
        viewBox="0 0 18 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
    >
        <path
            d="M17.5303 6.29693C17.8232 6.00404 17.8232 5.52917 17.5303 5.23627L12.7574 0.463302C12.4645 0.170408 11.9896 0.170408 11.6967 0.463302C11.4038 0.756195 11.4038 1.23107 11.6967 1.52396L15.9393 5.7666L11.6967 10.0092C11.4038 10.3021 11.4038 10.777 11.6967 11.0699C11.9896 11.3628 12.4645 11.3628 12.7574 11.0699L17.5303 6.29693ZM-6.55671e-08 6.5166L17 6.5166L17 5.0166L6.55671e-08 5.0166L-6.55671e-08 6.5166Z"
            fill={color}
        />
    </svg>
);

ArrowIcon.propTypes = propTypes;

export default ArrowIcon;
